import { Options } from '../../Options'
import { ChartPieConstants } from './ChartPie.constants'

export const chartPieOptions = Options.asRecord(
  Options.createOption({
    key: 'isDonut',
    inputKind: 'boolean',
    defaultValue: ChartPieConstants.defaultIsDonut,
    label: 'Donut variant',
    description:
      'When enabled, renders a donut (inner radius). When disabled, renders a full pie.',
    category: 'Pie',
  }),
  Options.createOption({
    key: 'showCenterTotal',
    inputKind: 'boolean',
    defaultValue: ChartPieConstants.defaultShowCenterTotal,
    label: 'Show center total',
    description:
      'On donut charts, show the total value and caption in the hole.',
    category: 'Pie',
  }),
  Options.createOption({
    key: 'otherThresholdPct',
    inputKind: 'number',
    defaultValue: ChartPieConstants.defaultOtherThresholdPct,
    min: 0,
    max: 50,
    step: 0.5,
    label: 'Other threshold (%)',
    description:
      'Slices below this share of total are grouped into "Other" when Top N is not set.',
    category: 'Pie',
  }),
  Options.createOption({
    key: 'minLabelPct',
    inputKind: 'number',
    defaultValue: ChartPieConstants.defaultMinLabelPct,
    min: 0,
    max: 100,
    step: 1,
    label: 'Minimum label (%)',
    description: 'Minimum slice share to show an outside percent label.',
    category: 'Pie',
  }),
  Options.createOption({
    key: 'centerTotalCaption',
    inputKind: 'text',
    defaultValue: ChartPieConstants.defaultCenterTotalCaption,
    label: 'Center caption',
    description: 'Label under the center total on donut charts.',
    category: 'Pie',
  }),
  Options.createOption({
    key: 'pieDiameter',
    inputKind: 'number',
    min: 120,
    max: 600,
    step: 4,
    label: 'Pie diameter',
    description: 'Plot diameter in pixels. Omit for the Figma default.',
    category: 'Pie',
  }),
)

export type ChartPieOptions = Options.TypeOf<typeof chartPieOptions>
